import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { FetchPerformanceTeamReviews, FetchPerformanceTeamReviewsSuccess } from 'app/library/performance-team-review/actions';
import { PerformanceTeamReview } from 'app/library/performance-team-review/models/performance-team-review.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, take } from 'rxjs/operators';

export class PreformanceReviewsDataSource implements DataSource<PerformanceTeamReview> {
    private _loadingSubject = new BehaviorSubject<boolean>(false);

    public loading$ = this._loadingSubject.asObservable();

    constructor(private _filteredPerformanceTeamReviews$: Observable<PerformanceTeamReview[]>, private _store: Store, private _action$: Actions) {}

    connect(collectionViewer: CollectionViewer): Observable<PerformanceTeamReview[]> {
        return this._filteredPerformanceTeamReviews$;
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this._loadingSubject.complete();
    }

    loadPerformanceTeamReviews(
        teamId: string,
        pageSize?: number,
        pageNumber?: number,
        search?: string,
        type?: string,
        periodUnderReview?: string,
        goalSettingPeriod?: string,
        userId?: string
    ): void {
        this._loadingSubject.next(true);

        this._store.dispatch(
            new FetchPerformanceTeamReviews({
                teamId,
                pageSize,
                pageNumber,
                search,
                type,
                periodUnderReview,
                goalSettingPeriod,
                userId,
            })
        );
        this._action$
            .pipe(
                ofActionDispatched(FetchPerformanceTeamReviewsSuccess),
                finalize(() => this._loadingSubject.next(false)),
                take(1)
            )
            .subscribe();
    }
}
